export default function authHeader() {
  // return {
  //
  //   "Iv-Remote-Address" : "127.0.0.1",
  //   "Accept-Language" : "th"
  // }

  const user = localStorage.getItem("token");
  const language = localStorage.getItem("lang");
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const ip = localStorage.getItem("ip");

  let lang = "th"
  if (language === "en-US") {
    lang = "en"
  } else if (language === "th-TH") {
    lang = "th"
  }


  if (user) {
    let header_data = {
      Authorization: "Bearer " + user,
      "Iv-Remote-Address": ip || "127.0.0.1",
      "Accept-Language": lang,
    };


    if (proxy?.proxy_token !== undefined) {
      header_data.proxy = proxy?.proxy_token
    }

    return header_data

    // Iv-Remote-Address: <<Client IP>>
    // Accept-Language: <<th,en>> (Optional: default `th`)
    // Authorization: Bearer <<Token>>
    // For Spring Boot back-end
    // return { Authorization: "Bearer " + user.accessToken };
    // for Node.js Express back-end
    // return { "x-access-token": user.accessToken };
  } else {
    return {
      "Iv-Remote-Address": "127.0.0.1",
    };
  }
}
